import React from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

const FooterContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 46px;
  background-color: #fbd800;
  box-shadow: 0px -2px 3.5px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 40px;
  box-sizing: border-box;
  z-index: 100;
`;

const LogoContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-right: -6px;
`;

const FooterLogo = styled.img`
  height: 15px;
  width: 67px;
`;

const RightIconWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  overflow: hidden;
  align-self: flex-end;
`;

const RightIconImg = styled.img`
  position: absolute;
  width: 95%;
  height: 95%;
  bottom: 0;
  left: 2.5%;
`;

const HelexiaFooter = () => {
  const { themeName } = useTheme();
  const { pathname } = useLocation();

  if (themeName !== 'helexia') return null;
  if (pathname === '/' || pathname === '/register') return null;

  return (
    <FooterContainer>
      <LogoContainer>
        <FooterLogo
          src="/companies/HELEXIA/helexia_footer_logo.svg"
          alt="Helexia"
        />
      </LogoContainer>
      <RightIconWrapper>
        <RightIconImg
          src="/companies/HELEXIA/mainLogo.png"
          alt=""
        />
      </RightIconWrapper>
    </FooterContainer>
  );
};

export default HelexiaFooter;
